'use strict';

import React from 'react';
import Collapsible from 'react-collapsible';
import AgreementCancelModal from '../agreement/AgreementCancelModal';
import classnames from 'classnames';

import Form from './Form';

import Logger from '../../utils/Logger';

const { id: module_id } = module;
const logger = Logger(module_id);

const CollapsibleForm = (props) => {
  const {
    showForm,
    toggleShowForm,
    form,
    values,
    editForm,
    addForm,
    toggleEditForm,
    showContent,
    toggleContentVisibility,
    toggleAddForm,
    handleValueChange,
    header,
    update,
    save,
    remove,
    errors,
    checkErrors,
  } = props;

  let collapsibleClassNames = classnames('ot-form', 'ot-collapsible-form', {
    'ot-collapsible-form--icon-open': showContent,
  });

  return (
    <Collapsible
      className={collapsibleClassNames}
      openedClassName={collapsibleClassNames}
      handleTriggerClick={toggleContentVisibility}
      open={showContent}
      trigger={
        <span>
          <i className={form.icon} /> <h2>{form.name}</h2>
        </span>
      }
    >
      {showForm && (
        <Form
          form={form}
          values={values}
          editForm={editForm}
          addForm={addForm}
          handleValueChange={handleValueChange}
          header={header}
          toggleEditForm={toggleEditForm}
          toggleAddForm={toggleAddForm}
          update={update}
          save={save}
          remove={remove}
          errors={errors}
          checkErrors={checkErrors}
        />
      )}
      {props.children}
    </Collapsible>
  );
};

export default CollapsibleForm;
